module.exports = __webpack_public_path__ + "img/w3_chevron_right_black.1836242f.1836242f.png";